
import { BillingOrder } from "../../Models/Billing";
import { getPaymentMethodLabel } from "../../Utils/Enums";
import { formatPriceBRL } from "../../Utils/DataFormatters";
import Modal from "../common/Modal/Modal";

type BillingFeeDetailsModalProps = {
  order: BillingOrder | null;
  onClose: () => void;
};

const getFeePayerLabel = (payer?: number | null) => {
  if (payer === 1) {
    return "Loja pagou";
  }
  if (payer === 2) {
    return "Cliente pagou";
  }
  return "Não informado";
};

const renderFeeBreakdownLine = (label: string, amount: number, meta?: string) => (
  <div className="flex justify-between items-center text-sm text-gray-700 py-2">
    <span>{label}</span>
    <span>
      {formatPriceBRL(amount)} {meta ? <span className="text-xs text-gray-500">{meta}</span> : null}
    </span>
  </div>
);

const BillingFeeDetailsModal = ({ order, onClose }: BillingFeeDetailsModalProps) => {
  const feeBreakdown = order?.feeBreakdown ?? null;

  return (
    <Modal
      isOpen={!!order}
      onClose={onClose}
      title={`Detalhes da taxa - Pedido #${order?.orderNumber ?? ""}`}
    >
      {feeBreakdown ? (
        <div className="flex flex-col gap-3">
          <div className="text-sm text-gray-600">
            {"Pagamento"}: {getPaymentMethodLabel(order?.paymentMethod ?? null)}
          </div>

          <div className="divide-y divide-gray-200">
            {feeBreakdown.gatewayFeeAmount > 0 &&
              renderFeeBreakdownLine(
                "Taxa gateway",
                feeBreakdown.gatewayFeeAmount,
                feeBreakdown.gatewayFeePercent > 0
                  ? `(${(feeBreakdown.gatewayFeePercent * 100).toFixed(2)}%)`
                  : ""
              )}

            {feeBreakdown.installmentFeeAmount > 0 &&
              renderFeeBreakdownLine(
                "Taxa de parcelamento/boleto",
                feeBreakdown.installmentFeeAmount,
                `(${getFeePayerLabel(feeBreakdown.installmentFeePaidBy)})`
              )}

            {renderFeeBreakdownLine("Total de taxas", feeBreakdown.totalFeeAmount)}
          </div>
        </div>
      ) : (
        <p className="text-sm text-gray-600">{"Sem detalhes disponíveis."}</p>
      )}
    </Modal>
  );
};

export default BillingFeeDetailsModal;
